/* eslint-disable no-undef */
import axios from 'axios'
//import { useRouter } from 'vue-router'
import router from '../router'
import { useAuthStore } from '../stores/auth-store'

const getToken = () => {
  const token = localStorage.getItem('HMadminToken')
  if (typeof token !== 'string' || token == '') console.log('gettoken: no token found', token)
  return token
}

const API_URL = import.meta.env.DEV
  ? import.meta.env.VITE_APP_API_URL
  : 'https://' + document.location.hostname.replace('admin.', 'api.')
console.log('APIURL', API_URL)

//const router = useRouter()
axios.defaults.paramsSerializer = (params) =>
  Object.keys(params)
    .filter((key) => params[key] !== undefined)
    .map((key) => {
      if (Object.prototype.toString.call(params[key]) === '[object Object]') {
        params[key] = JSON.stringify(params[key])
      }
      if (Array.isArray(params[key])) {
        return params[key].map((v: any) => `${key}[]=${encodeURIComponent(v)}`).join('&')
      }
      return `${key}=${encodeURIComponent(params[key])}`
    })
    .join('&')
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + getToken(),
  },
})

axiosInstance.interceptors.response.use(
  function (response) {
    if (response.headers['authtoken']) {
      // console.log(response.headers);
      // localStorage.setItem('HMadminToken', response.headers['authtoken'])
      const authStore = useAuthStore()
      // console.log('refresh with token ', response.headers['authtoken'])
      authStore.refreshUserData(response.headers['authtoken'])
    }
    //console.log('response',response)
    return response
  },
  function (error) {
    const axios_error = error
    // Null-safe check
    const status = axios_error?.response?.status ?? null
    //console.log('axioserr',axios_error)
    if (!status) {
      return { data: { Error: 'API Error' } }
    }
    if (status == 401) {
      // eslint-disable-next-line no-undef
      if (axios_error.config && axios_error.config.url && axios_error.config.url == '/login') {
        console.log('axerr', axios_error)
      } else {
        router.push({ name: 'login' }) //alert('go to login')
      }
    } else if (![400, 422].includes(status)) {
      return { data: { Error: 'API Error: ' + error.message } }
    }

    return Promise.reject(axios_error)
  },
)

export default axiosInstance
